import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ReactLogo from './logo-react.png'
import JSlogo from './logo-js.png'
import NodeLogo from './logo-node.png';
import ExpressLogo from './logo-express.png'
import reduxLogo from './logo-redux.png'
import logoBS from './logo-bs.png';
import { useEffect, useState } from 'react';
export function Skills() {
    const [activeSKill, setActiveSkill] = useState({});
    const skills = [
        "React",
        "JavaScript",
        "Node JS",
        "Express",
        "Bootstrap",
        "Redux"
    ]
    function handleHover(n) {
        return setActiveSkill({ index: n, text: skills[n] })
    }

    useEffect(() => { }, [activeSKill])

    return (
        <Container  className='mt-5 skill-section' id="skills">
            <h2 className='text-white'>My Top Skills</h2>
            <Row className='m-3'>
                <Col>
                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body onHover={() => handleHover(0)}>
                            <img src={ReactLogo} className="w-50 " />
                            <div className='card-overlay'>
                                <p>
                                    React
                                </p>
                            </div>
                        </Card.Body>
                    </Card></Col>
                <Col>
                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body onHover  ={() => handleHover(1)}>
                            <img src={JSlogo} className="w-50 " />
                            <div className='card-overlay'>
                                <p>
                                    JavaScript
                                </p>
                            </div>

                        </Card.Body>
                    </Card>
                </Col>
                <Col>

                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body onHover={() => handleHover(2)}>
                            <img src={NodeLogo} className="w-50 " />
                            <div className='card-overlay'>
                                <p>
                                    Node JS
                                </p>
                            </div>
                        </Card.Body>
                    </Card>

                </Col>
            </Row>
            <Row className='m-3'>
                <Col>
                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body onClick={() => handleHover(3)}>
                            <img src={ExpressLogo} className="w-50 " />
                            <div className='card-overlay'>
                                <p>
                                    Express
                                </p>
                            </div>
                        </Card.Body>
                    </Card></Col>
                <Col>
                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body onClick={() => handleHover(4)}>
                            <img src={logoBS} className="w-50 " />
                            <div className='card-overlay'>
                                <p>
                                    Bootstrap
                                </p>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>

                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body onClick={() => handleHover(5)}>
                            <img src={reduxLogo} className="w-50 " />
                            <div className='card-overlay'>
                                <p>
                                    Redux
                                </p>
                            </div>
                        </Card.Body>
                    </Card>

                </Col>
            </Row>
        </Container>
    );
}